import React, { useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import { Navigate, useSearchParams } from "react-router-dom";
import { ComparatorShell, LAST_KEY } from "./ComparatorPage";
import products from "@/lib/comparators.json";

const GROUPS = ["Santé & prévoyance", "Crédit", "Professionnels", "Biens & vie quotidienne"];

export default function ComparatorHub() {
  const [params] = useSearchParams();
  const uuid = params.get("uuid");
  const last = uuid && products.find((p) => p.slug === localStorage.getItem(LAST_KEY));
  useEffect(() => {
    const prev = document.title;
    document.title = "Comparateur d'assurances en ligne — santé, prévoyance, auto, habitation | MD Courtage";
    window.scrollTo(0, 0);
    return () => { document.title = prev; };
  }, []);

  if (last) return <Navigate to={`/comparateur/${last.slug}/offres?uuid=${encodeURIComponent(uuid)}`} replace />;
  const suffix = uuid ? `/offres?uuid=${encodeURIComponent(uuid)}` : "";

  return (
    <ComparatorShell testId="comparator-hub">
      <main className="max-w-6xl mx-auto px-6 py-14 md:py-20">
        <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-4">Comparateur d'assurances</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-md-primary font-medium leading-tight mb-5 max-w-3xl">Comparez vos assurances en quelques minutes</h1>
        <p className="text-lg text-md-muted max-w-2xl mb-14">Obtenez instantanément des tarifs auprès de plusieurs assureurs, puis profitez de l'accompagnement de votre courtier pour choisir la bonne garantie.</p>
        {uuid && <p data-testid="comparator-uuid-notice" className="bg-white border border-md-secondary/40 rounded-2xl px-5 py-4 text-md-primary mb-10">Votre demande est enregistrée : choisissez le produit concerné pour afficher vos offres.</p>}
        {GROUPS.map((g) => (
          <section key={g} className="mb-12">
            <h2 className="font-serif text-2xl text-md-primary mb-5">{g}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {products.filter((p) => p.group === g).map((p) => (
                <a key={p.slug} href={`/comparateur/${p.slug}${suffix}`} data-testid={`comparator-card-${p.slug}`} className="group bg-white border border-md-border rounded-3xl p-6 hover:border-md-secondary/50 hover:-translate-y-1 transition-[transform,border-color] duration-300">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <h3 className="font-serif text-xl text-md-primary font-medium">{p.name}</h3>
                    <ArrowUpRight className="w-5 h-5 text-md-secondary flex-shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </div>
                  <p className="text-sm text-md-muted leading-relaxed">{p.desc}</p>
                </a>
              ))}
            </div>
          </section>
        ))}
      </main>
    </ComparatorShell>
  );
}
